<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row class="mb-1" v-if="item">
        <b-col>
          <router-link v-if="showServiceman" class="btn btn-sm" :to="{name: 'ServicemenUpdate', params: { id: item['@id'] }}">
            <span v-if="!mobileView">{{ $t('buttons.edit') }}</span>
            <i v-else class="far fa-edit"></i>
          </router-link>
          <router-link v-else-if="showClient" class="btn btn-sm" :to="{name: 'ClientUpdate', params: { id: item['@id'] }}">
            <span v-if="!mobileView">{{ $t('buttons.edit') }}</span>
            <i v-else class="far fa-edit"></i>
          </router-link>
          <router-link v-else class="btn btn-sm" :to="{name: 'UserDataUpdate', params: { id: item['@id'] }}">
            <span v-if="!mobileView">{{ $t('buttons.edit') }}</span>
            <i v-else class="far fa-edit"></i>
          </router-link>
          <button class="btn btn-sm btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
          <b-btn size="sm" v-if="userIRI" @click="goToUserShow(userIRI)">
            <span v-if="!mobileView">{{ $t('buttons.goToAccountData') }}</span>
            <i v-else class="far fa-user-alt"></i>
          </b-btn>
          <b-btn v-else size="sm" @click="createUserToUserData()">
            <span v-if="!mobileView">{{ $t('buttons.createAccount') }}</span>
            <i v-else class="far fa-user-plus"></i>
          </b-btn>
          <router-link v-if="prevRoute.name === 'EXCMAgreementList'" :to="{ name: 'EXCMAgreementList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToAgreementList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else-if="prevRoute.name === 'Overview'" :to="{ name: 'Overview' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToDashboard')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else-if="prevRoute.name === 'FirmShow'" :to="{ name: 'FirmShow', params: { id: prevRoute.params.id } }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToFirm')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else-if="routeName === 'UserDataShow'" :to="{ name: 'UserDataList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else-if="routeName === 'ServicemenShow'" :to="{ name: 'ServicemenList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row v-if="item">
        <b-col>
          <b-card>
            <b-row>
            </b-row>
            <b-card-body>
              <b-row>
                <b-col sm="12" lg="8">
                  <b-row>
                    <b-col sm="12" lg="6">
                      <p v-if="(showUserData || showServiceman || showClient) && (item.name && item.surname)"><b>{{$t('views.userdata.show.nameAndSurname')}}:</b> {{ item.name }} {{ item.surname }}</p>
                      <p v-if="(showUserData || showServiceman || showClient) && item.idClientType && item.idClientType.title"><b>{{$t('views.userdata.show.idClientType')}}:</b> {{ item.idClientType.title }} </p>
                      <p v-if="showUserData && item.city"><b>{{$t('views.userdata.show.city')}}:</b> {{ item.city }} </p>
                      <p v-if="showUserData && item.street"><b>{{$t('views.userdata.show.street')}}:</b> {{ item.street }} </p>
                      <p v-if="showUserData && item.postcode"><b>{{$t('views.userdata.show.postcode')}}:</b> {{ item.postcode }} </p>
                      <p v-if="showUserData && item.province"><b>{{$t('views.userdata.show.province')}}:</b> {{ item.province }} </p>
                    </b-col>
                    <b-col sm="12" lg="6">
                      <p v-if="(showUserData || showServiceman || showClient) && item.mobilePhone"><b>{{$t('views.userdata.show.mobilePhone')}}:</b> <phoneNumberLink :phoneNumber="item.mobilePhone"/></p>
                      <p v-if="showUserData && item.nip"><b>{{$t('views.userdata.show.nip')}}:</b> {{ item.nip }} </p>
                      <p v-if="(showUserData || showServiceman || showClient) && item.userEmail"><b>{{$t('views.userdata.show.userEmail')}}:</b><a :href="'mailto: ' + item.userEmail"> {{ item.userEmail }}</a> </p>
                      <p v-if="showUserData && item.birthplace"><b>{{$t('views.userdata.show.birthplace')}}:</b> {{ item.birthplace }} </p>
                      <p v-if="showUserData && item.birthday"><b>{{$t('views.userdata.show.birthday')}}:</b> {{ item.birthday }} </p>
                      <p v-if="item.extraInfo"><b>{{$t('views.firm.form.extraInfo')}}:</b> {{item.extraInfo}}</p>
                      <p v-if="item.idSalesRepresentative"><b>{{$t('views.userdata.form.idSalesRepresentative')}}:</b> {{item.idSalesRepresentative.name}} {{item.idSalesRepresentative.surname}}</p>
                    </b-col>
                  </b-row>
                  <ServicemanCars v-if="routeName === 'ServicemenShow'" :serviceman="item"></ServicemanCars>
                </b-col>
                <b-col sm="12" lg="4">
                  <AvatarDisplay v-model="avatarChanged" :item="item"></AvatarDisplay>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="item && $store.getters['configuration/mailerLiteStatus']">
        <b-col>
          <b-card>
            <div class="card-header">
              <h6>{{$t('views.userdata.show.mailerLiteStatusInfo')}}:</h6>
            </div>
            <div class="card-body">
              <user-data-mailer-lite-box :data="item"></user-data-mailer-lite-box>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="item && ableToShowFirm">
        <b-col>
          <b-card>
            <div class="card-header">
              <h6>{{$t('views.userdata.show.hiredIn')}}:</h6>
            </div>
            <div class="card-body">
              <table v-if="item.userDataFirms.length > 0" class="table table-sm table-striped table-hover mb-3">
                <thead>
                <tr>
                  <th>{{$t('views.userdata.show.userDataFirm.firmname')}}:</th>
                  <th>{{$t('views.userdata.show.userDataFirm.city')}}:</th>
                  <th>{{$t('views.userdata.show.userDataFirm.street')}}:</th>
                  <th>{{$t('views.userdata.show.userDataFirm.province')}}:</th>
                  <th>{{$t('views.userdata.show.userDataFirm.postcode')}}:</th>
                  <th>{{$t('views.userdata.show.userDataFirm.country')}}:</th>
                  <th v-if="displaySalesRepresentative">{{$t('views.userdata.form.idSalesRepresentative')}}:</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(userDataFirm, userDataFirmIndex) in item.userDataFirms" v-bind:key="'userDataFirm-' + userDataFirmIndex">
                  <td><router-link :to="{ name: 'FirmShow', params: { id: userDataFirm.firm['@id'] }}">{{ userDataFirm.firm.firmname1 }}</router-link></td>
                  <td>{{ userDataFirm.firm.city }}</td>
                  <td>{{ userDataFirm.firm.street }}</td>
                  <td>{{ userDataFirm.firm.province }}</td>
                  <td>{{ userDataFirm.firm.postcode }}</td>
                  <td>{{ userDataFirm.firm.country }}</td>
                  <td v-if="displaySalesRepresentative">
                    <span v-if="userDataFirm.firm.idSalesRepresentative">{{ userDataFirm.firm.idSalesRepresentative.name }} {{ userDataFirm.firm.idSalesRepresentative.surname }}</span>
                  </td>
                  <td>
                    <div class="btn-group float-right">
                      <router-link :to="{ name: 'FirmShow', params: { id: userDataFirm.firm['@id'] }}">
                        <button
                          type="button"
                          class="btn btn-link fa fa-eye fa-lg"
                          v-b-tooltip :title="$t('views.userdata.show.userDataFirm.options.goToFirm')">
                        </button>
                      </router-link>
                      <button
                        type="button"
                        class="btn btn-link fa fa-edit fa-lg"
                        @click="updateFirm(userDataFirm)"
                        v-b-tooltip :title="$t('views.userdata.show.userDataFirm.options.editFirm')">
                      </button>
                      <button
                        type="button"
                        class="btn btn-link fa fa-trash fa-lg"
                        @click="deleteFirm(userDataFirm)"
                        v-b-tooltip :title="$t('views.userdata.show.userDataFirm.options.deleteFirm')">
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <b-row>
                <b-col>
                  <b-btn size="sm" class="mt-2 btn btn-success" @click="addNewFirm()">{{ $t('views.userdata.show.userDataFirm.options.addNewFirm') }}</b-btn>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <UserDataAddresses :id-user-data="item['@id']"></UserDataAddresses>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <CreateUserDataFirmModal></CreateUserDataFirmModal>
    <UpdateUserDataFirmModal></UpdateUserDataFirmModal>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import getId from '@/utils/getIdFromLink'
import Loader from '../../Layout/Loader'
import AvatarDisplay from './component/AvatarDisplay/AvatarDisplay'
import ServicemanCars from './component/ServicemanCars/ServicemanCars'
import UserDataAddresses from '@/components/Dashboard/Views/userdataaddress/List'
import CreateUserDataFirmModal from '@/components/Dashboard/Views/userdatafirm/components/CreateUserDataFirmModal'
import UpdateUserDataFirmModal from '@/components/Dashboard/Views/userdatafirm/components/UpdateUserDataFirmModal'
import UserDataMailerLiteBox from '@/components/Dashboard/Views/userdata/component/MailerLite/userDataMailerLiteBox'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  components: {
    PhoneNumberLink,
    UserDataMailerLiteBox,
    UpdateUserDataFirmModal,
    CreateUserDataFirmModal,
    UserDataAddresses,
    Loader,
    AvatarDisplay,
    ServicemanCars
  },

  computed: {
    ...mapGetters({
      updatedItem: 'userdata/update/updated',
      deleteError: 'userdata/del/error',
      error: 'userdata/show/error',
      isLoading: 'userdata/show/isLoading',
      item: 'userdata/show/retrieved',
      userdatafirmupdated: 'userdatafirm/update/updated',
      userdatafirmcreated: 'userdatafirm/create/created'
    }),
    ableToShowFirm () {
      return this.checkRoles('firms', 'FirmShow')
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    showUserData () {
      if (this.routeName === 'UserDataShow') {
        return true
      } else {
        return false
      }
    },
    showServiceman () {
      if (this.routeName === 'ServicemenShow') {
        return true
      } else {
        return false
      }
    },
    showClient () {
      if (this.routeName === 'ClientShow') {
        return true
      } else {
        return false
      }
    },
    displaySalesRepresentative () {
      for (let i in this.item.userDataFirms) {
        if (this.item.userDataFirms[i].firm.idSalesRepresentative) {
          return true
        }
      }
      return false
    }
  },

  data () {
    return {
      routeName: '',
      prevRoute: '',
      userIRI: null,
      avatarChanged: 0,
      cars: []
    }
  },

  beforeCreate () {
    // this.routeName = this.$route.name
    // if (this.routeName === 'ServicemenShow') {
    //   checkPagePermission('servicemen', 'ServicemenShow')
    // } else {
    //   checkPagePermission('userdatas', 'UserDataShow')
    // }
    // // checkPagePermission('userdatas', 'UserDataShow')
  },

  beforeDestroy () {
    this.reset()
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  watch: {

    userdatafirmcreated: function (userdatafirmcreated) {
      if (!userdatafirmcreated) {
        return
      }
      this.$store.state.modals.userdatafirm.create.created = 1
      this.$store.state.modals.userdatafirm.create.close = 1
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    userdatafirmupdated: function (updated) {
      this.$store.state.modals.userdatafirm.update.updated = 1
      this.$store.state.modals.userdatafirm.update.close = 1
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    avatarChanged: function () {
      if (this.avatarChanged === 1) {
        this.avatarChanged = 0
        this.retrieve(decodeURIComponent(this.$route.params.id))
      }
    },

    item: function (val) {
      if (this.item) {
        let users = this.item.users
        if (users.length === 1) {
          this.userIRI = users[0]
        } else {
          this.userIRI = null
        }
        if (this.item.birthday) {
          this.item.birthday = this.$moment(this.item.birthday).format('YYYY-MM-DD')
        }
      }
    }
  },

  created () {
    this.routeName = this.$route.name
    if (this.routeName === 'ServicemenShow') {
      checkPagePermission('servicemen', 'ServicemenShow')
    } else {
      checkPagePermission('userdatas', 'UserDataShow')
    }
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'userdata/del/del',
      reset: 'userdata/show/reset',
      retrieve: 'userdata/show/retrieve'
    }),

    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/user_datas/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              let redirectRouter = ''
              if (this.showServiceman) {
                redirectRouter += 'ServicemenList'
              } else if (this.showClient) {
                redirectRouter += 'ClientList'
              } else {
                redirectRouter += 'UserDataList'
              }
              this.$router.push({ name: redirectRouter })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },

    goToUserShow (userIRI) {
      this.$router.push({ name: 'UserShow', params: { id: userIRI } })
    },

    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },

    createUserToUserData () {
      this.userIRI = null
      this.$http.post('api/user_datas/' + this.getIdLink(this.item['@id']) + '/add_user', {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          if (response.status === 201) {
            this.retrieve(decodeURIComponent(this.$route.params.id))
            this.$Swal({
              type: 'success',
              title: this.$t('notifications.operationDone'),
              timer: 2500
            })
          }
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    deleteItem (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.del(item).then(() => this.$router.push({ name: 'UserDataList' }))
        }
      })
    },
    addNewFirm () {
      this.$store.state.modals.userdatafirm.create.show = 1
      this.$store.state.modals.userdatafirm.create.userIRI = this.item['@id']
    },
    updateFirm (item) {
      this.$store.state.modals.userdatafirm.update.userDataFirmPivot = item
      this.$store.state.modals.userdatafirm.update.show = 1
    },
    deleteFirm (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(response => {
        this.del(item).then(this.retrieve(decodeURIComponent(this.$route.params.id)))
        this.$Swal({
          title: this.$t('notifications.deletedTitle'),
          type: 'success'
        })
      })
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
